import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getItemStocksLocation } from "../../../../services/inventory/itemService";
import withGlobalData from "../../common/withGlobalData";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
class SearchItemStocksLocation extends Component {
  state = {
    reload: this.props.globalData.reload,
    stocksLocation: [],
  };
  componentDidMount() {
    this.getItemStocksLocations();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getItemStocksLocations();
      this.setState({ reload: globalData.reload });
    }
  }

  async getItemStocksLocations() {
    let { itemID, varCode, warehouseID, uomID } = this.props;
    if (varCode === "") {
      varCode = "-";
    }
    const response = await getItemStocksLocation(
      itemID,
      varCode,
      warehouseID,
      uomID
    );
    const { data } = response.data;
    this.setState({ stocksLocation: data.stocksLocation });
  }

  render() {
    const { stocksLocation } = this.state;
    return (
      <CustomDataTableSearch
        data={stocksLocation}
        onRefreshData={() => {
          this.getItemStocksLocations();
        }}
        onSelectedData={(rowData, originalEvent) => {
          this.props.onSelectLocation(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => this.props.onSelectLocation(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Location Name",
            field: "locationName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.locationName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Item Type",
            field: "itemTypeName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            hidden: true,
          },
          {
            header: "Item Code",
            field: "itemCode",
            body: (rowData) => (
              <React.Fragment>
                {rowData.itemType > 0 ? (
                  <span>
                    <BootstrapTooltip title={rowData.itemTypeName}>
                      <span className="mr-2">
                        <i
                          className={
                            rowData.itemType === 1
                              ? "fas fa-boxes text-success"
                              : rowData.itemType === 2
                              ? "fas fa-tools text-primary"
                              : rowData.itemType === 3
                              ? "fas fa-building text-info"
                              : rowData.itemType === 4
                              ? "fas fa-boxes text-warning"
                              : rowData.itemType === 5
                              ? "fas fa-boxes text-danger"
                              : null
                          }
                        ></i>
                      </span>
                    </BootstrapTooltip>
                    <span>
                      <ResponsiveEllipsis
                        text={rowData.itemCode}
                        maxLine="1"
                        displayInline
                      />
                    </span>
                  </span>
                ) : (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
                  </React.Fragment>
                )}
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Item Name",
            field: "itemName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Quantity",
            field: "qty",
            body: (rowData) => (
              <div>
                {rowData.qty} {rowData.uom}
              </div>
            ),
            sortable: true,
          },
          {
            header: "Unit",
            field: "uom",
            body: null,
            sortable: true,
            hidden: true,
          },
          {
            header: "Batch ID",
            field: "batchID",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchItemStocksLocation);
